import React from 'react';
import PropTypes from 'prop-types';
import { graphql, gql, compose } from 'react-apollo';

// Style
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './FooterBlock.css';

// Component
import FooterBlockForm from '../../../components/siteadmin/FooterBlockForm';
import Loader from '../../../components/Loader';

class FooterBlock extends React.Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.shape({
      loading: PropTypes.bool,
      getFooterSettting: PropTypes.object,
    })
  };

  static defaultProps = {
    data: {
      loading: true,
      image: null
    }
  };


  render() {
    const { data: { loading, getFooterSetting }, title } = this.props;
    if (loading) {
      return <Loader type={"text"} />;
    } else {
      return <FooterBlockForm initialValues={getFooterSetting} title={title} />
    }
  }

}

export default compose(
  withStyles(s),
  graphql(gql`
        {
            getFooterSetting {
                id
                title1
                title1_en
                title1_fr
                title1_it
                title1_pt
                content1
                content1_en
                content1_fr
                content1_it
                content1_pt
                title2
                title2_en
                title2_fr
                title2_it
                title2_pt
                content2
                content2_en
                content2_fr
                content2_it
                content2_pt
                title3
                title3_en
                title3_fr
                title3_it
                title3_pt
                content3
                content3_en
                content3_fr
                content3_it
                content3_pt
            }
        }
      `, {
    options: {
      ssr: false,
      fetchPolicy: 'network-only'
    }
  }),
)(FooterBlock);
